<template>
  <div>
    <el-drawer
      :visible.sync="userDrawerShow"
      :wrapperClosable="true"
      :size="320"
      :with-header="false"
      @closed="closed"
    >
      <div class="content">
        <div class="title">
          <div class="text">账号信息</div>
          <img
            class="close"
            src="@/assets/image/close.webp"
            alt=""
            @click="setUserDrawerShow(false)"
          />
        </div>
        <div class="userinfo">
          <el-avatar :size="40" :src="user.avatar" />
          <div class="userinfo_r">
            <div class="userinfo_r_t">
              <div class="name">{{ user.name }}</div>
              <AuthIcon :type="authType" />
            </div>
            <div class="userinfo_r_b">
              {{ user.phone }}
            </div>
          </div>
        </div>
        <div class="menu">
          <div class="item" @click="toQiyeguanli" v-show="user.creator">
            <img
              class="img"
              src="@/assets/image/home/header/icon_5.webp"
              alt=""
              srcset=""
            />
            <div class="text">企业管理</div>
          </div>
          <div class="item" @click="toGerenzhongxin">
            <img
              class="img"
              src="@/assets/image/home/header/icon_6.webp"
              alt=""
              srcset=""
            />
            <div class="text">个人中心</div>
          </div>
        </div>
        <div class="solid"></div>
        <div class="title">当前账号</div>
        <div class="history">
          <div
            class="item"
            :class="{ active: isActive(item.uuid) }"
            v-for="item in userLogList"
            :key="item.uuid"
            @click="changeUser(item)"
          >
            <!-- 未认证 -->
            <img
              class="item_l"
              src="@/assets/image/home/header/icon_7.webp"
              alt=""
              srcset=""
              v-if="authTypeFn(item.auth, item.company) === 'unAuth'"
            />
            <!-- 未企业认证 -->
            <img
              class="item_l"
              src="@/assets/image/home/header/icon_3.webp"
              alt=""
              srcset=""
              v-if="authTypeFn(item.auth, item.company) === 'unCompanyAuth'"
            />
            <!-- 已认证 -->
            <img
              class="item_l"
              src="@/assets/image/home/header/icon_4.webp"
              alt=""
              srcset=""
              v-if="authTypeFn(item.auth, item.company) === 'allAuth'"
            />
            <div class="item_c">
              <div class="name">{{ item.name }}</div>
              <div
                class="company"
                v-if="authTypeFn(item.auth, item.company) === 'unAuth'"
              >
                未实名认证
              </div>
              <div
                class="company"
                v-if="authTypeFn(item.auth, item.company) === 'unCompanyAuth'"
              >
                未企业认证
              </div>
              <div
                class="company"
                v-if="authTypeFn(item.auth, item.company) === 'allAuth'"
              >
                {{ item.company.name }}
              </div>
            </div>
            <img
              class="item_r"
              src="@/assets/image/home/select_y.webp"
              alt=""
              srcset=""
              v-if="isActive(item.uuid)"
            />
            <img
              class="item_r"
              src="@/assets/image/home/select_n.png"
              alt=""
              srcset=""
              v-else
            />
          </div>
        </div>
        <div class="footer">
          <el-button class="btn" @click="logoutFn">退出登录</el-button>
          <el-button class="btn" type="primary" @click="add">添加账号</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo";
import { mapState, mapMutations, mapActions } from "vuex";
import AuthIcon from "@/components/AuthIcon/index.vue";
export default {
  mixins: [userinfo],
  components: { AuthIcon },
  data() {
    return {};
  },
  created() {},
  computed: {
    userDrawerShow: {
      get() {
        return this.$store.state.app.userDrawerShow;
      },
      set(val) {
        this.setUserDrawerShow(val);
      },
    },

    ...mapState("userLog", ["userLogList"]),
  },
  methods: {
    ...mapActions("app", ["setUserDrawerShow"]),
    ...mapActions("user", ["changeToken", "logout"]),
    closed() {
      this.setUserDrawerShow(false);
    },
    isActive(uuid) {
      return this.user.uuid === uuid;
    },
    changeUser({ uuid, token }) {
      console.log(uuid, token);
      if (this.user.uuid === uuid) {
        return;
      }
      this.setUserDrawerShow(false);
      this.changeToken(token);
    },
    logoutFn() {
      this.$router.push({
        path: "/login",
      });
      this.setUserDrawerShow(false);
      this.logout();
    },
    add() {
      this.$router.push({
        path: "/login",
      });
      this.setUserDrawerShow(false);
    },
    async toQiyeguanli() {
      try {
        await this.verifyUserAuth();
        await this.verifyCompanyAuth();
        this.$router.push({ name: "enterprise" });
      } finally {
        this.setUserDrawerShow(false);
      }
    },
    async toGerenzhongxin() {
      try {
        await this.verifyUserAuth();
        await this.verifyCompanyAuth();
        this.$router.push({ name: "accountManagement" });
      } finally {
        this.setUserDrawerShow(false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  height: 100vh;
  position: relative;
  padding: 0;
  .title {
    display: flex;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    position: relative;
    .text {
      color: #262626;
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: 500;
    }
    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 15px;
      right: 16px;
      cursor: pointer;
    }
  }

  .userinfo {
    display: flex;
    padding: 0 16px;
    height: 76px;
    align-items: center;
    gap: 12px;

    &_r {
      gap: 4px;
      display: flex;
      flex-direction: column;

      &_t {
        display: flex;
        align-items: center;
        gap: 6px;

        .name {
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: 500;
          color: #262626;
        }
      }

      &_b {
        font-family: "Noto Sans SC";
        font-size: 12px;
        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #999999;
      }
    }
  }

  .menu {
    .item {
      height: 46px;
      padding: 0 16px;
      gap: 6px;
      display: flex;
      align-items: center;
      cursor: pointer;

      .img {
        width: 20px;
        height: 20px;
      }

      .text {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #262626;
      }
    }
  }

  .solid {
    width: 288px;
    height: 1px;
    background: #eeeeee;
    margin: 12px auto;
  }

  .title {
    height: 46px;
    display: flex;
    align-items: center;
    padding: 0 16px;

    font-size: 14px;
    font-weight: 500;
    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #262626;
  }

  .history {
    gap: 6px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 355px);
    overflow-y: auto;

    .item {
      width: calc(100% - 32px);
      margin: 0 auto;

      height: 58px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 8px 12px;
      cursor: pointer;
      &_l {
        margin-right: 6.5px;
        align-self: flex-start;
        margin-top: 3px;
        width: 12.5px;
        height: 15px;
      }

      &_c {
        flex: 1;

        .name {
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: 500;
          color: #262626;
          line-height: 20px;
        }

        .company {
          font-family: "Noto Sans SC";
          font-size: 12px;
          font-variation-settings: "opsz" auto;
          font-feature-settings: "kern" on;
          color: #666666;
          margin-top: 4px;
          line-height: 17px;
        }
      }

      &_r {
        width: 16px;
        height: 16px;
      }
    }

    .active {
      background: #f6faff;
    }
  }

  .footer {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 16px;
    width: 100%;

    .btn {
      width: 80px;
      height: 34px;
    }
  }
}
</style>
